import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";

import ProcessServerProfile from "./components/Profile";
import ProcessServerFTPConfiguration from "./components/FTPConfiguration";

import Footer from "../../../components/shared/Footer";
import * as APIModels from "../../../models";
import { ProcessServerService } from "../../../services/ClientService";

export default function ProcessServerEditPage() {
    const { id } = useParams<{ id?: string }>();
    const [processServer, setProcessServer] = useState(
        new APIModels.ProcessServer()
    );
    const [errorMessage, setErrorMessage] = useState("");

    useEffect(() => {
        ProcessServerService.get({ id: id ?? "" }).then(
            (resp) => {
                if (resp.successful === true && resp.data) {
                    setProcessServer(resp.data);
                    console.log("resp id " + JSON.stringify(resp.data));
                } else {
                    setErrorMessage(resp.message ?? "");
                }
            },
            (error) => {
                setErrorMessage(error);
            }
        );
        if (errorMessage) {
            console.log(errorMessage);
            setErrorMessage("");
        }
    }, []);

    return (
        <div className="content">
            <div className="container-fluid">
                <div className="row">
                    <div className="col-12">
                        <div className="page-title-box page-title-box-alt">
                            <h4 className="page-title">Process Server Edit</h4>
                            <div className="page-title-right">
                                <ol className="breadcrumb m-0">
                                    <li className="breadcrumb-item">
                                        <a href="javascript: void(0);">
                                            eFileMadeEasy
                                        </a>
                                    </li>
                                    <li className="breadcrumb-item">
                                        <a href="javascript: void(0);">Admin</a>
                                    </li>
                                    <li className="breadcrumb-item">
                                        <a href="javascript: void(0);">
                                            Process Servers
                                        </a>
                                    </li>
                                    <li className="breadcrumb-item active">
                                        Process Server Edit
                                    </li>
                                </ol>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="row">
                    <div className="col-lg-6 col-xl-6">
                        <ProcessServerProfile processServer={processServer} />
                    </div>
                    <div className="col-lg-6 col-xl-6">
                        <ProcessServerFTPConfiguration
                            processServer={processServer}
                        />
                    </div>
                </div>
            </div>
            <Footer />
        </div>
    );
}
